export default "__VITE_ASSET__5GeVlleV__"